import React from "react";
import { useTranslation } from "react-i18next";

import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import { EMPTY_STRING, EVENT_BOOKING_TABS } from "../../../constants";
import { Box, Stepper, Step, StepLabel } from "@mui/material";

const ACTIVE_COLOR = "#5FB4BE";
const INACTIVE_COLOR = "#C6C6C6";

const CustomConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: { top: 19 },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: INACTIVE_COLOR,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: ACTIVE_COLOR,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: ACTIVE_COLOR,
  },
  left: "calc(-50% + 16px) !important",
  right: "calc(50% + 16px) !important",
}));

const CustomStepIconRoot = styled("div")(({ active, completed }) => ({
  color: active || completed ? ACTIVE_COLOR : INACTIVE_COLOR,
  border: `2px solid ${active || completed ? ACTIVE_COLOR : INACTIVE_COLOR}`,
  borderRadius: "50%",
  width: 35,
  height: 35,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

function CustomStepIcon({ active, completed, icon, iconsMap }) {
  return (
    <CustomStepIconRoot active={active} completed={completed}>
      <Box
        sx={{ display: "flex", height: 15 }}
        className={active ? "active-icons" : EMPTY_STRING}
      >
        {iconsMap[String(icon)]}
      </Box>
    </CustomStepIconRoot>
  );
}

const HorizontalStepper = ({
  activeStep,
  steps,
  onStepClick,
  iconsMap,
  disableInActiveTabs,
  isDraftEvent,
}) => {
  const { t } = useTranslation("common");

  const stepKeys = Object.keys(steps);
  const draftEvent = isDraftEvent
    ? Object.keys(steps).find(
        (key) => steps[key] === EVENT_BOOKING_TABS.EVENT_SETUP
      )
    : null;

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<CustomConnector />}
        sx={{ maxWidth: 850, mx: "auto", "& .MuiStep-root": { flex: 1 } }}
      >
        {stepKeys.map((stepKey, index) => (
          <Step key={stepKey} sx={{ px: 0 }}>
            <StepLabel
              StepIconComponent={(props) => (
                <CustomStepIcon
                  {...props}
                  iconsMap={iconsMap}
                  active={index <= activeStep}
                />
              )}
              onClick={() =>
                !(draftEvent === stepKey) &&
                disableInActiveTabs &&
                onStepClick(index)
              }
              sx={{
                cursor:
                  index <= activeStep &&
                  disableInActiveTabs &&
                  !(draftEvent === stepKey)
                    ? "pointer"
                    : "not-allowed !important",
                minWidth: "48px",
                "& .MuiStepLabel-label": {
                  color:
                    index === activeStep
                      ? `${ACTIVE_COLOR} !important`
                      : "#353535",
                  fontWeight:
                    index === activeStep ? `600 !important` : "400 !important",
                  fontSize: "0.813rem",
                  "@media (max-width:700px)": {
                    fontSize: "0.72rem",
                  },
                },
              }}
            >
              <Box sx={{ display: { xs: "none", sm: "block" } }}>
                {t(steps[stepKey])}
              </Box>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default HorizontalStepper;
